import { render, staticRenderFns } from "./AddToWishList.vue?vue&type=template&id=4c3118d2&"
import script from "./AddToWishList.vue?vue&type=script&lang=js&"
export * from "./AddToWishList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/Ceres_Build_Stable/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c3118d2')) {
      api.createRecord('4c3118d2', component.options)
    } else {
      api.reload('4c3118d2', component.options)
    }
    module.hot.accept("./AddToWishList.vue?vue&type=template&id=4c3118d2&", function () {
      api.rerender('4c3118d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/AddToWishList.vue"
export default component.exports